import { Trash2 } from 'lucide-react';

import { useCheckout } from '~/hooks/use-checkout';
import { useAppLead } from '~/hooks/useAppLead';
import { useProducts } from '~/hooks/useProducts';

import { familyPlansIds, familyPlanToProductMap } from './FamilyPlanUpgradeBox';

export const FamilyPlanOrderItem = () => {
  const { selectedPlan } = useCheckout();
  const { updateUser } = useAppLead();
  const { findProductById } = useProducts();

  const isFamilyPlanSelected = familyPlansIds.includes(selectedPlan?.id || '');

  const handleRemoveFamilyPlan = () => {
    updateUser({
      selectedPlan: findProductById(familyPlanToProductMap[selectedPlan?.id || '142']),
    });
  };

  return (
    <>
      {isFamilyPlanSelected ? (
        <>
          <div className='flex justify-between items-center'>
            <div className='flex items-center gap-2'>
              <span className='text-sm text-dark'>+ Family Plan</span>
              <button onClick={handleRemoveFamilyPlan} className='text-red-500' aria-label='Remove family plan'>
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
